import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, ErrorHandler, provideAppInitializer, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, provideRouter, withComponentInputBinding } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FullCalendarModule } from '@fullcalendar/angular';
import { routes } from './app.routes';
import { ReportService } from './core/services/report.service';
import { authTokenInterceptor } from './core/interceptors/auth-token.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserModule, FontAwesomeModule, FormsModule, FullCalendarModule, ReactiveFormsModule, RouterModule),
    provideHttpClient(withXhr(), withInterceptors([authTokenInterceptor])),
    provideAppInitializer(() => {
      const reportService = inject(ReportService);
      reportService.initSignalRClient();
    }),
    {
      provide: ErrorHandler,
      useFactory: () => new BugsnagErrorHandler()
    },
    provideRouter(routes, withComponentInputBinding())
  ]
};
